import { Box, CircularProgress, createStyles, IconButton, makeStyles, MenuItem, TextField, Typography } from "@material-ui/core";
import { OrderItem } from "common-ts/dist/models/Orders";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useFormik } from "formik";
import { FareastButton } from "./OverlayComponentButton";
import { useState } from "react";

const useStyles = makeStyles(() =>
    createStyles({
        arrowBackButton: {
            color: "black",
            padding: "0 0 15px 0",
        },
        title: {
            fontWeight: 600,
            fontSize: "1.2rem",
        },
        productsContainer: {
            display: "flex",
            flexDirection: "column",
            marginTop: "15px",
        },
        productItem: {
            borderRadius: "15px",
            padding: "15px",
            marginBottom: "15px",
            display: "flex",
            flexDirection: "column",
            border: "1px solid #8a8a8aff",
        },
        productDetail: {
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "stretch",
        },
        productName: {
            fontSize: "0.85rem",
            fontWeight: 500,
            marginBottom: "5px",
        },
        sizeName: {
            fontSize: "0.7rem",
            color: "#8a8a8aff",
        },
        textBox: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginLeft: "10px",
            flex: 1,
            minHeight: 0,
        },
        formField: {
            marginTop: "12px",
        },
    })
);

interface Props {
    handleBack: () => void;
    handleNext: (serviceInputDesc: any[]) => void;
    selectedProducts: OrderItem[];
}

export default function ServiceInput({ handleBack, handleNext, selectedProducts }: Props) {
    const classes = useStyles();

    const formik = useFormik({
        initialValues: {
            items: selectedProducts.map(() => ({
                layanan: "",
                keterangan: "",
            })),
        },
        onSubmit: (values) => {
            let serviceInputDescription = [];
            for (let i = 0; i < selectedProducts.length; i++) {
                let sizeName = "";
                if (selectedProducts[i].sizeType === "personal") {
                    const meas = selectedProducts[i].userMeasurementsForItem;
                    if (typeof meas === "string") {
                        sizeName = meas;
                    } else {
                        sizeName = meas.measurementName || "NOTSELECTED";
                    }
                } else {
                    sizeName = selectedProducts[i].regularSize;
                }

                serviceInputDescription.push({
                    productName: selectedProducts[i].productDetail.name,
                    productImage: selectedProducts[i].productDetail.displayImage,
                    productSize: selectedProducts[i].regularSize,
                    category: values.items[i].layanan,
                    description: values.items[i].keterangan,
                });
            }

            handleNext(serviceInputDescription);
        },
    });

    const layananOptions = [
        { value: "TUKAR_SIZE", label: "Tukar Size" },
        { value: "PERMAK", label: "Permak" },
        { value: "GENERAL", label: "General" },
    ];

    if (!selectedProducts || selectedProducts.length === 0) {
        handleBack();
    }

    return (
        <Box>
            <IconButton onClick={handleBack} className={classes.arrowBackButton}>
                <ArrowBackIcon />
            </IconButton>
            <Typography className={classes.title}>Pilih Layanan Yang Diperlukan</Typography>
            <form onSubmit={formik.handleSubmit}>
                <Box className={classes.productsContainer}>
                    {selectedProducts.map((item: OrderItem, index) => {
                        let sizeName = "";
                        if (item.sizeType === "personal") {
                            const meas = item.userMeasurementsForItem;
                            if (typeof meas === "string") {
                                sizeName = meas;
                            } else {
                                sizeName = meas.measurementName || "NOTSELECTED";
                            }
                        } else {
                            sizeName = item.regularSize;
                        }

                        return (
                            <Box key={index} className={classes.productItem}>
                                <Box className={classes.productDetail}>
                                    <img src={item.productDetail.displayImage} alt={`Gambar ${item.productDetail.name}`} style={{ width: "60px", marginTop: "auto", marginBottom: "auto" }} />
                                    <Box className={classes.textBox}>
                                        <Typography className={classes.productName}>{item.productDetail.name}</Typography>
                                        <Typography className={classes.sizeName}>{sizeName}</Typography>
                                    </Box>
                                </Box>
                                <TextField
                                    select
                                    fullWidth
                                    variant="standard"
                                    id={`items[${index}].layanan`}
                                    name={`items[${index}].layanan`}
                                    value={formik.values.items[index].layanan}
                                    onChange={formik.handleChange}
                                    className={classes.formField}
                                    SelectProps={{ displayEmpty: true }}
                                >
                                    <MenuItem value="">
                                        <Typography style={{ color: "#bcbcbcff" }}>Pilih Layanan</Typography>
                                    </MenuItem>
                                    {layananOptions.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </MenuItem>
                                    ))}
                                </TextField>

                                <TextField
                                    fullWidth
                                    variant="standard"
                                    id={`items[${index}].keterangan`}
                                    name={`items[${index}].keterangan`}
                                    placeholder="Keterangan"
                                    value={formik.values.items[index].keterangan}
                                    onChange={formik.handleChange}
                                    className={classes.formField}
                                />
                            </Box>
                        );
                    })}
                </Box>
                <Box style={{ width: "100%", textAlign: "right" }}>
                    <FareastButton
                        disabled={formik.values.items.some((item) => item.layanan.trim() === "" || item.keterangan.trim() === "")}
                        style={{ cursor: "pointer" }}
                        type="submit"
                        buttonMarginLeftRight="0px"
                        buttonMarginTopBottom="15px"
                    >
                        LANJUT
                    </FareastButton>
                </Box>
            </form>
        </Box>
    );
}
